/*
  smb-fit-row.js — squeezes a row's button to its icon when the row cannot
  hold it at full size (Sam, 2026-09-30: "for narrow widths the add to cart
  button can turn into cart icon with a plus icon and arrow buttons can just
  turn into an arrow").

  A [data-fit-row] element (the price-and-button foot of a Shop all or
  bundles row) is measured, not compared with a width typed anywhere: it
  fits when nothing overflows it and its price line (.smb-shop-row-priceline,
  one line tall with overflow hidden) shows everything, the struck total
  included. When it does not fit it takes .is-compact, and brand-ui.css draws
  its button as the icon alone. Each time the row resizes it is tried at full
  size first, so a row that has room again gets its label back.

  Within one list every foot is squeezed together or none is.

  A file, not an inline script, for the Section Rendering reason in CLAUDE.md
  ("Bundles"); new rows (a filter swap, Load more) are picked up as they
  arrive. Without JavaScript the full button stays and the struck total is
  what gives way.
*/
(function () {
  'use strict';
  if (window.smbFitRow) return;

  function fits(row) {
    if (row.scrollWidth > row.clientWidth + 1) return false;
    // The price line is one line tall; an item that wrapped (the struck
    // total) starts below it. Descenders overhang by a pixel or two, so it is
    // where an item starts that counts, not the line's scroll height.
    var line = row.querySelector('.smb-shop-row-priceline');
    if (line) {
      var bottom = line.getBoundingClientRect().bottom;
      for (var i = 0; i < line.children.length; i++) {
        if (line.children[i].getBoundingClientRect().top >= bottom - 1) return false;
      }
    }
    return true;
  }

  // Sibling rows agree: the feet of one list are all squeezed or all full, so
  // one row's full button never sits beside another's bare icon. A list is the
  // nearest [data-shop-list] / .smb-shop-list, else the feet's shared parent.
  function listOf(row) {
    return row.closest('[data-shop-list], .smb-shop-list') || (row.parentElement && row.parentElement.parentElement) || document;
  }

  function fit(row) {
    var list = listOf(row);
    var feet = list.querySelectorAll('[data-fit-row]');
    var compact = false;
    var i;
    // Try every foot at full size first, so a list with room gets its labels
    // back together, then squeeze them all if any one cannot hold its button.
    for (i = 0; i < feet.length; i++) feet[i].classList.remove('is-compact');
    for (i = 0; i < feet.length; i++) {
      if (!fits(feet[i])) {
        compact = true;
        break;
      }
    }
    if (compact) for (i = 0; i < feet.length; i++) feet[i].classList.add('is-compact');
  }

  var observer =
    'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            fit(entry.target);
          });
        })
      : null;

  function watch(root) {
    var rows = (root || document).querySelectorAll('[data-fit-row]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].__smbFit) continue;
      rows[i].__smbFit = true;
      fit(rows[i]);
      if (observer) observer.observe(rows[i]);
    }
  }

  function refitAll() {
    var rows = document.querySelectorAll('[data-fit-row]');
    for (var i = 0; i < rows.length; i++) fit(rows[i]);
  }

  window.smbFitRow = { watch: watch, refit: refitAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watch();
    });
  } else {
    watch();
  }
  // The price and button measure again once the web fonts are in.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refitAll);
  // Rows swapped in by the shop filter or appended by Load more.
  document.addEventListener('smb:section:refresh', function () {
    watch();
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          watch();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
